import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import getDefaultListId from './get-default-list-id';
import isWishlistItemActive from './is-wishlist-item-active';
import getWishlistItemsQueryKey from "../lists/get-query-key";

/**
 * Flattens pages from infinite query cache into a single array of items, with
 * items the wishlists v2 service flagged as not buyable for this marketplace
 * filtered out — see `is-wishlist-item-active.js` for the contract.
 * @param {Object} data - The infinite query data with pages and pageParams
 * @returns {Array} Flattened array of active wishlist items
 */
var selectListItemsFlat = function selectListItemsFlat(data) {
  if (!(data !== null && data !== void 0 && data.pages)) return undefined;
  return data.pages.reduce(function (accu, current) {
    return [].concat(_toConsumableArray(accu), _toConsumableArray(((current === null || current === void 0 ? void 0 : current.objects) || []).filter(isWishlistItemActive)));
  }, []);
};
var getListItems = function getListItems(_ref) {
  var queryClient = _ref.queryClient;
  var listId = getDefaultListId({
    queryClient: queryClient
  });
  if (!listId) return undefined;
  var infiniteQueryData = queryClient.getQueryData(getWishlistItemsQueryKey({
    id: listId
  }));
  return selectListItemsFlat(infiniteQueryData);
};
export default getListItems;